import {
  Fuel, Flame, Gem, Zap, Mountain, Factory, Wheat, Coffee, Droplets,
  Candy, CircleDollarSign, Sparkles, Layers, Package, Leaf,
} from "lucide-react";

const ICONS = {
  "Crude Oil": Fuel, "Natural Gas": Flame, "Gold": CircleDollarSign, "Copper": Layers,
  "Iron Ore": Mountain, "Coal": Factory, "Silver": Sparkles, "Lithium": Zap,
  "Maize": Wheat, "Wheat": Wheat, "Soybeans": Leaf, "Coffee": Coffee, "Sugar": Candy,
  "Platinum": Gem, "Chrome": Layers, "Vanadium": Zap, "Nickel": Layers,
  "Palladium": Gem, "Rice": Wheat, "Salt": Sparkles, "Sunflower Oil": Droplets,
  "Diamonds": Gem, "Bauxite": Mountain, "Aluminium": Layers, "Manganese": Package,
};

// Clean, uniform, professional icon tile (no bright "emoji" colours)
export default function CommodityIcon({ name, size = 22, className = "", rounded = 12 }) {
  const Icon = ICONS[name] || Package;
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{
        background: "var(--surface-2)",
        border: "1px solid var(--border)",
        color: "var(--text)",
        borderRadius: rounded,
        width: size + 18,
        height: size + 18,
      }}
    >
      <Icon size={size} strokeWidth={1.75} />
    </div>
  );
}
